import React from 'react';
import BrandPageTemplate from './BrandPageTemplate';
import hpLogo from '../../assets/brands/hp.png';

const HPSupport = () => (
    <BrandPageTemplate
        
        brandImage={hpLogo}
        description="Professional support for HP printers including LaserJet, OfficeJet, DeskJet, and Envy series."
    />
);

export default HPSupport;
